import { mCoresPrimarias, mCoresSecundarias, mCoresPrimariasDark, mCoresSecundariasDark } from "../constants/coresArray"
import pegarModoAtual from "../helpers/pegarModoAtual"

/**
 * Função que retorna uma cor de fundo específica ou uma versão mais pálida,
 * considerando o modo atual (light/dark).
 * @param {string} cCorHex - Cor hexadecimal (por exemplo "#FF0000")
 * @param {string[]} [mCoresVerificar] - Array opcional de cores hexadecimais para verificação
 * @param {string} [cCorPadrao] - Cor padrão usada se não encontrada (padrão: "#F4F4F4")
 * @returns {string} Cor de fundo resultante em formato hexadecimal
 */
export const pegarCorDeFundo = (cCorHex, mCoresVerificar, cCorPadrao) => {
  try {
    const cModo = pegarModoAtual()
    const mCoresPrimariasAtuais = mCoresPrimarias
    const mCoresSecundariasAtuais = mCoresSecundarias
    const mCoresPrimariasDarkAtuais = mCoresPrimariasDark
    const mCoresSecundariasDarkAtuais = mCoresSecundariasDark

    // Define valores padrão caso não sejam passados
    const mCoresVerificarUsar = mCoresVerificar || mCoresPrimariasAtuais
    const cCorPadraoUsar = cCorPadrao || "#F4F4F4"

    if (!cCorHex || typeof cCorHex !== "string") {
      return cCorPadraoUsar
    }

    const cCorNormalizada = cCorHex.startsWith("#") ? cCorHex.toLowerCase() : `#${cCorHex.toLowerCase()}`

    // Obtém o índice da cor no array de cores 'light'
    const nIndice = mCoresVerificarUsar.findIndex((cCor) => {
      const cCorItemNormal = cCor.startsWith("#") ? cCor.toLowerCase() : `#${cCor.toLowerCase()}`
      return cCorItemNormal === cCorNormalizada
    })

    // Se a cor estiver na lista, retorna a cor secundária correspondente
    if (nIndice !== -1) {
      if (cModo === "dark" && mCoresSecundariasDarkAtuais[nIndice]) {
        return mCoresSecundariasDarkAtuais[nIndice]
      }
      if (mCoresSecundariasAtuais[nIndice]) {
        return mCoresSecundariasAtuais[nIndice]
      }
    }

    return tornarCorMaisPalida(cCorNormalizada)
  } catch (oErro) {
    console.log("Erro ao processar cor de fundo:", oErro)
    return cCorPadrao || "#F4F4F4"
  }
}

/**
 * Função auxiliar para tornar uma cor mais pálida
 * @param {string} cCorHex - Cor hexadecimal a ser clareada
 * @param {number} [nFatorClaridade=0.7] - Fator de mistura com branco (0-1)
 * @returns {string} Cor mais pálida em formato hexadecimal
 */
const tornarCorMaisPalida = (cCorHex, nFatorClaridade = 0.7) => {
  const cCor = cCorHex.replace("#", "")

  const nR = parseInt(cCor.substring(0, 2), 16)
  const nG = parseInt(cCor.substring(2, 4), 16)
  const nB = parseInt(cCor.substring(4, 6), 16)

  const nNovoR = Math.round(nR + (255 - nR) * nFatorClaridade)
  const nNovoG = Math.round(nG + (255 - nG) * nFatorClaridade)
  const nNovoB = Math.round(nB + (255 - nB) * nFatorClaridade)

  const cComponenteR = nNovoR.toString(16).padStart(2, "0")
  const cComponenteG = nNovoG.toString(16).padStart(2, "0")
  const cComponenteB = nNovoB.toString(16).padStart(2, "0")

  return `#${cComponenteR}${cComponenteG}${cComponenteB}`
}
